import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let CharactersViewSheet = class CharactersViewSheet extends Vue {
};
__decorate([
    Prop(Object)
], CharactersViewSheet.prototype, "characterValidation", void 0);
CharactersViewSheet = __decorate([
    Component
], CharactersViewSheet);
export default CharactersViewSheet;
